import React from "react";
import { FormattedMessage, MessageDescriptor, useIntl } from "react-intl";
import { HelpText, LimitSelectControl } from "./CategoryLimitsField.styles";
import { categoryLimitsMessages } from "./CategoryLimitsField.messages";
import { LimitSelectViewModel } from "./categoryLimitBlock.viewModel";
import { FieldErrors } from "./FieldErrors";

interface LimitSelectProps {
  view: LimitSelectViewModel;
  label: MessageDescriptor;
  help: MessageDescriptor;
  accommodation: string;
  onChange: (value: string) => void;
}

/** *Included in the price* (0–10) / *Maximum allowed* (1–10), with its help text. */
export function LimitSelect({ view, label, help, accommodation, onChange }: LimitSelectProps) {
  const intl = useIntl();
  const invalid = view.errors.length > 0;
  return (
    <div className="form-group">
      <label htmlFor={view.id}>
        <FormattedMessage {...label} />
      </label>
      <LimitSelectControl
        id={view.id}
        className={invalid ? "form-control is-invalid" : "form-control"}
        value={view.value}
        aria-describedby={invalid ? `${view.helpId} ${view.errorId}` : view.helpId}
        aria-invalid={invalid || undefined}
        onChange={event => onChange(event.target.value)}>
        <option value="">{intl.formatMessage(categoryLimitsMessages.placeholder)}</option>
        {view.options.map(option => (
          <option key={option} value={String(option)}>
            {option}
          </option>
        ))}
      </LimitSelectControl>
      <HelpText id={view.helpId}>
        <FormattedMessage {...help} values={{ accommodation }} />
      </HelpText>
      <FieldErrors id={view.errorId} messages={view.errors} />
    </div>
  );
}
